import { BASE_URL } from '../../constants/baseUrl';
import axiosInstance from '../../utils/axiosInstance';

const bookingDashboardService = {
  fetchBookingStats: () => {
    return axiosInstance.get(`${BASE_URL}/v1/shipments/status`);
  },
  fetchTripStats: () => {
    return axiosInstance.get(`${BASE_URL}/v1/trips/status`);
  },
  fetchBookingAnalytics: (promotionData) => {
    return axiosInstance.get(`${BASE_URL}/v1/booking/analytics`, {
      params: promotionData,
    });
  },
};

export default bookingDashboardService;
